// extracted by mini-css-extract-plugin
export default {"videoPlayerCard":"VideoCardSliderSmall_videoPlayerCard__5TXVC","playIcon":"VideoCardSliderSmall_playIcon__eOJv3","img":"VideoCardSliderSmall_img__sfvvG"};